export const mockProperties = [
  {
    id: "B-104",
    name: "Apex Heights",
    address: "492 Tech Boulevard, Sector 4",
    units: 24,
    occupancy: 95,
    status: "healthy",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1200&auto=format&fit=crop",
    manager: "S. Jenkins",
    revenue: "$92.4k"
  },
  {
    id: "B-201",
    name: "The Foundry Lofts",
    address: "18 Industrial Way",
    units: 12,
    occupancy: 100,
    status: "maintenance",
    image: "https://images.unsplash.com/photo-1577495508048-b635879837f1?q=80&w=1200&auto=format&fit=crop",
    manager: "M. Chen",
    revenue: "$48.2k"
  },
  {
    id: "B-305",
    name: "Riverside Estates",
    address: "99 Water Street",
    units: 45,
    occupancy: 82,
    status: "attention",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=1200&auto=format&fit=crop",
    manager: "E. Rodriguez",
    revenue: "$112.9k"
  }
];

export const mockTickets = [
  { id: "T-8992", title: "HVAC System Failure", property: "Apex Heights", status: "todo", priority: "high", date: "Today" },
  { id: "T-8993", title: "Water Ingress - Lobby", property: "Riverside Estates", status: "todo", priority: "high", date: "Today" },
  { id: "T-8985", title: "Elevator Modernization", property: "The Foundry Lofts", status: "in-progress", priority: "medium", date: "2 days ago" },
  { id: "T-8970", title: "Access Control Update", property: "Apex Heights", status: "done", priority: "low", date: "1 week ago" }
];

export const mockRentStatus = [
  { unit: "4B", tenant: "Sarah Jenkins", amount: "$2,400", status: "paid", avatar: "SJ" },
  { unit: "12A", tenant: "Marcus Chen", amount: "$1,850", status: "pending", avatar: "MC" },
  { unit: "7C", tenant: "Elena Rodriguez", amount: "$3,100", status: "overdue", avatar: "ER" },
  { unit: "2A", tenant: "David Kim", amount: "$1,900", status: "paid", avatar: "DK" },
];

export const revenueData = {
  months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  collected: [45000, 46200, 44800, 48000, 47500, 51000],
  projected: [46000, 46000, 46000, 49000, 49000, 52000]
};